var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("transition", { attrs: { name: "fade" } }, [
    _vm.isOpen
      ? _c(
          "ul",
          { staticClass: "cd-accordion-menu" },
          _vm._l(_vm.mobileMenu, function(menuItem, index) {
            return _c("MenuItem", {
              key: menuItem.title + index,
              attrs: { model: menuItem }
            })
          }),
          1
        )
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }